/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const getProjectsProjectidPreferencesUnitsUnitidPathProjectIdSchema = z.string()

export const getProjectsProjectidPreferencesUnitsUnitidPathUnitIdSchema = z.string()

export const getProjectsProjectidPreferencesUnitsUnitidStatus200Schema = z.object({
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
})

export const getProjectsProjectidPreferencesUnitsUnitidStatus401Schema = z.string()

export const getProjectsProjectidPreferencesUnitsUnitidStatus404Schema = z.string()

export const getProjectsProjectidPreferencesUnitsUnitidStatus500Schema = z.string()

export const getProjectsProjectidPreferencesUnitsUnitidResponseSchema = getProjectsProjectidPreferencesUnitsUnitidStatus200Schema

export const getProjectsProjectidPreferencesUnitsUnitidErrorSchema = z.union([getProjectsProjectidPreferencesUnitsUnitidStatus401Schema, getProjectsProjectidPreferencesUnitsUnitidStatus404Schema, getProjectsProjectidPreferencesUnitsUnitidStatus500Schema])

export const getProjectsProjectidPreferencesUnitsUnitidPathSchema = z.object({
  projectId: z.string(),
  unitId: z.string(),
})
